import React from 'react';

import { ReactComponent as Check } from 'assets/icons/green-check.svg';

const BeneficiaryInstructionContent = {
  title: "Set up your beneficiaries",
  subtitle: "To leave your IRA assets to an individual or entity, name them as the beneficiary on the account. Upon your death, your beneficiary generally can invest the assets in an inherited IRA.",
  stepTitle: "You will need:",
  steps: [],
  notes: [
    {
      content: "Your beneficiary’s legal name",
      icon: <Check />
    },
    {
      content: "The type of beneficiary (individual or entity) and for individuals, their relationship to you",
      icon: <Check />
    },
    {
      content: "The percentage of assets you want them to inherit",
      icon: <Check />
    }
  ]
};

export default BeneficiaryInstructionContent;
